<template>
<!-- Category -->
<div style="width=100%;background:#fff;">
<a-row :gutter="16" style="padding-top:5px;padding-bottom:5px;background:#5e5;">
    <a-col :span="24">
    <Searchbar />
    </a-col>
</a-row>

<a-list
    :grid="{ gutter: 16, xs: 2, sm: 2, md: 4, lg: 4, xl: 6, xxl: 3, xxxl: 2 }"
    :data-source="categories"
>
    <template #renderItem="{ item }">
      <a-list-item>
        <div style="width:100%;">
        <p>{{item.cate_name}}</p>
        </div>
      </a-list-item>
    </template>
</a-list>

</div>
</template>
<script>
  import { onMounted, inject, reactive } from 'vue'
  import Searchbar from '@/components/Searchbar.vue'
  import { getCategory } from '@/utils/api'
  export default {
    name: 'Categories',
    components: {Searchbar},
    methods: {
      
    },
    mounted() {
        this.$store.commit('showNav',false)
        getCategory(0).then(data => {
            console.log('data: ')
            console.log(data.categories)
            for( const cate of data.categories) {
                this.categories.push(cate)
            }
        })

    },
    setup() {
        const Valid = inject('$Valid')
        var categories = reactive([])
        onMounted(() => {

        })
        return { Valid, categories}
    }
  };
</script>
<style lang="scss" scoped>

</style>